// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_c6-2";
export var aiChatCartContainerExit = "_c6-4";
export var aiChatContainerLarge = "_c6-0";
export var aiChatContainerSmall = "_c6-1";
export var aiChatIcon = "_c6-6";
export var slideInFromRight = "_c6-3";
export var slideOutToRight = "_c6-5";